module.exports = __webpack_public_path__ + "static/media/lacanada.5855ebdf.mp4";